import { Directive } from '@angular/core';
import { Subject } from 'rxjs';
import { DrawerEvents, DrawerWidth, PrimaryActionEvent } from '../definitions/drawer.definitions';
import { FormBase } from '../definitions/forms/form.definitions';
import { BaseViewComponent } from './base-view.component';

@Directive()
export abstract class DrawerBaseViewComponent<T = void> extends BaseViewComponent {
    readonly DrawerWidth = DrawerWidth;

    data!: T;
    events!: Subject<DrawerEvents>;
    CloseDrawer!: Function;

    PrimaryActionClicked!: Function;

    private _primaryActionEvent: Subject<PrimaryActionEvent> = new Subject();
    private _isFullscreen: boolean = false;

    abstract PrimaryAction(): void;

    constructor() {
        super();
        this._primaryActionEvent.subscribe(value => {
            switch (value) {
                case PrimaryActionEvent.Clicked:
                    this.PrimaryActionClicked && this.PrimaryActionClicked(true);
                    this.events?.next(DrawerEvents.PrimaryAction);
                    break;
                case PrimaryActionEvent.Fail:
                    this.PrimaryActionClicked && this.PrimaryActionClicked(false);
                    break;
            }
        })
    }

    DismissAction(): void {
        FormBase.currentForm?.Cancelled();
        this.CloseDrawer();
    }

    SecondaryAction(): void {
        this.events.next(DrawerEvents.SecondaryAction);
    }

    ScrollToTop() {
        const element = document.querySelector('.scss-drawer-layout') as HTMLElement;
        element?.scrollTo({ top: 0, behavior: 'smooth' });
    }

    get primaryActionEvent(): Subject<PrimaryActionEvent> {
        return this._primaryActionEvent;
    }

    get isFullscreen(): boolean {
        return this._isFullscreen;
    }
}
